/**
 * useFriendRequests Hook (Web)
 * Thin wrapper around shared useFriendRequests
 */

import { useAuth } from '@contexts/AuthContext';
import { createHttpClient } from '@parlay-picker/shared/api/httpClient';
import {
  type UseFriendRequestsResult,
  useFriendRequests as useFriendRequestsShared,
} from '@parlay-picker/shared/hooks';
import { useMemo } from 'react';
import { API_BASE_URL } from '../config/api';

export type { UseFriendRequestsResult };

export function useFriendRequests(): UseFriendRequestsResult {
  const { isAuthenticated, authFetch } = useAuth();

  const httpClient = useMemo(
    () => createHttpClient({ authFetch, baseUrl: API_BASE_URL }),
    [authFetch],
  );

  return useFriendRequestsShared({ httpClient, isAuthenticated });
}
